// Shared localStorage access for the softphone window's cross-window state.
//
// The softphone popup and the main thymebox tabs are separate browsing
// contexts with separate Pinia stores, so anything one needs to tell the
// others has to go through storage the browser shares. Every access is
// wrapped because localStorage throws outright when storage is disabled
// (Safari private browsing, hardened enterprise profiles) — a softphone that
// can't read a status flag must still be able to place calls. See CT-821.

/**
 * Reads a softphone state value, or null if absent or storage is unavailable.
 * @param key
 */
export function readSoftphoneState(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

/**
 * Writes a softphone state value. Silently does nothing if storage is
 * unavailable — callers must not depend on the write having happened.
 * @param key
 * @param value
 */
export function writeSoftphoneState(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Storage unavailable — nothing to fall back to.
  }
}

/**
 * Removes a softphone state value.
 * @param key
 */
export function clearSoftphoneState(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // Storage unavailable — nothing to fall back to.
  }
}
